<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewAllocation"
            :searchFilters="searchFilters"
            @searchPage="searchAllocations"
            @resetFilters="resetFilters"
            @removeItem="removeAllocation"
            @removeSelectedItems="removeAllocations"
            @printList="printCasesList"
            @printExcel="downloadCasesExcel"
            @printCSV="downloadCasesCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="allocList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :groupingKey=true
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveAllocation" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import PrintJS from 'print-js';

export default{
    name: 'Project_Allocations',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const emplComponentKey = ref(0);
        const levComponentKey = ref(0);
        const idField = 'project_allocation_id';
        const addButtonLabel = ref('New Allocation');
        const addingRight = ref('Adding Project Allocations');
        const removingRight = ref('Deleting Project Allocations');
        const rightsModule = ref('HR');
        const title = ref('Allocation Details');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const allocList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const employeeID = ref('');
        const projectID = ref('');
        const isEditing = computed(()=> store.state.Project_Allocations.isEditing);
        const selectedAllocation = computed(()=> store.state.Project_Allocations.selectedAllocation);
        const selectedEmployee = computed(()=> store.state.Project_Allocations.selectedEmployee);
        const selectedProject = computed(()=> store.state.Project_Allocations.selectedProject);
        const employeeArray = computed(() => store.state.Employees.employeeArr);
        const projectArray = computed(() => store.state.Projects.projectArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Project Name", key:"project_name"},
            {label: "Role", key: "role"},
            {label: "Date From", key: "from_date"},
            {label: "Date To", key: "to_date"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Assign', rightName: 'Editing Project Allocations'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Assign', rightName: 'Deleting Project Allocations'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const employee_name_search = ref('');
        const staff_number_search = ref('');
        const date_from_search = ref('');
        const date_to_search = ref('');
        const project_name_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Project...", value: project_name_search, width:32,},
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:32,},
            {type:'text', placeholder:"Employee Name...", value: employee_name_search, width:48,},
            {type:'date',value: date_from_search, width:32, title: "Date From"},
            {type:'date',value: date_to_search, width:32, title: "Date To"},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchEmployees = async() =>{
            await store.dispatch('Employees/fetchEmployees', {company:companyID.value})
        };
        const handleSelectedEmployee = async(option) =>{
            await store.dispatch('Employees/handleSelectedEmployee', option)
            employeeID.value = store.state.Employees.employeeID;
        };
        const clearSelectedEmployee = async() =>{
            await store.dispatch('Employees/updateState', {employeeID: ''});
            employeeID.value = store.state.Employees.employeeID;
        };
        const fetchProjects = async() =>{
            await store.dispatch('Projects/fetchProjects', {company:companyID.value})
        };
        const handleSelectedProject = async(option) =>{
            await store.dispatch('Projects/handleSelectedProject', option)
            projectID.value = store.state.Projects.projectID;
        };
        const clearSelectedProject = async() =>{
            await store.dispatch('Projects/updateState', {projectID: ''});
            projectID.value = ""
        };
        const formFields = ref([]);
        const employeeValue = computed(() => {
           return (selectedAllocation.value && selectedAllocation.value.employee && !employeeID.value) ? selectedAllocation.value.employee.employee_id : employeeID.value;

        });
        const projectValue = computed(() => {
           return (selectedAllocation.value && selectedAllocation.value.project && !projectID.value) ? selectedAllocation.value.project.project_id : projectID.value;

        });
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Project", value: projectValue.value, componentKey: levComponentKey,
                    selectOptions: projectArray, optionSelected: handleSelectedProject, required: true,
                    searchPlaceholder: 'Select Project...', dropdownWidth: '500px', updateValue: selectedProject.value,
                    clearSearch: clearSelectedProject
                },
                {  
                    type:'search-dropdown', label:"Employee", value: employeeValue.value, componentKey: emplComponentKey,
                    selectOptions: employeeArray, optionSelected: handleSelectedEmployee, required: true,
                    searchPlaceholder: 'Select Employee...', dropdownWidth: '500px', updateValue: selectedEmployee.value,
                    clearSearch: clearSelectedEmployee
                },
                { type: 'date', name: 'from_date',label: "From Date", value: selectedAllocation.value?.from_date || '', required: true },
                { type: 'date', name: 'to_date',label: "To Date", value: selectedAllocation.value?.to_date || '', required: false },
                { type: 'text', name: 'role',label: "Role", value: selectedAllocation.value?.role || '', required: false },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            projectID.value = '';
            employeeID.value = '';
        }


        watch([selectedAllocation, selectedEmployee, selectedProject], () => {
            if (selectedAllocation.value && selectedEmployee.value && selectedProject.value) {
                emplComponentKey.value += 1;
                levComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createProjectAllocation = async() =>{
            showModalLoader();
            let formData = {
                from_date: formFields.value[2].value,
                to_date: formFields.value[3].value || null,
                role: formFields.value[4].value,
                employee: employeeID.value,
                employee_id: employeeID.value,
                project: projectID.value,
                project_id: projectID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=2; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(employeeValue.value == '' || projectValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Project_Allocations/createProjectAllocation', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Success!');
                        handleReset();
                        emplComponentKey.value += 1;
                        levComponentKey.value += 1;
                    }
                    else {
                        toast.error('An error occurred while creating the Allocation.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Allocation: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchAllocations();
                }
            }
        }
        const updateProjectAllocation = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                project_allocation: selectedAllocation.value.project_allocation_id,
                from_date: formFields.value[2].value,
                to_date: formFields.value[3].value || null,
                role: formFields.value[4].value,
                employee: employeeValue.value,
                employee_id: employeeValue.value,
                project: projectValue.value,
                project_id: projectValue.value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(employeeValue.value == '' || projectValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Project_Allocations/updateProjectAllocation', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        emplComponentKey.value += 1;
                        toast.success("Sucess!");              
                    } else {
                        toast.error('An error occurred while updating the Allocation.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Allocation: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Project_Allocations/updateState",{selectedAllocation:null, selectedProject: null, selectedEmployee: null})
                    searchAllocations();
                }             
            }
        }
        const saveAllocation = () =>{
            if(isEditing.value == true){
                updateProjectAllocation();
            }else{
                createProjectAllocation();
            }
        }
        const removeAllocation = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    project_allocation: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Project_Allocations/deleteProjectAllocation',formData)
                    if(response && response.status == 200){
                        toast.success("Success");
                        searchAllocations();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Allocation: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Allocation") 
            }else{
                toast.error("Please Select An Allocation To Remove")
            }
        }
        const removeAllocations = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    project_allocation: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Project_Allocations/deleteProjectAllocation',formData)
                    if(response && response.status == 200){
                        toast.success("Success");
                        searchAllocations();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Allocation: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Allocation To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchAllocations = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                date_from: date_from_search.value,
                date_to: date_to_search.value,
                project_name: project_name_search.value,
                company: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/project-allocations-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                allocList.value = response.data.results;
                store.commit('Project_Allocations/LIST_PROJECT_ALLOCATIONS', allocList.value)
                propResults.value = response.data;
                propArrLen.value = allocList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchAllocations(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            staff_number_search.value = "";
            employee_name_search.value = "";
            date_from_search.value = "";
            date_to_search.value = "";
            project_name_search.value = "";
            searchAllocations();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchAllocations();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchAllocations();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchAllocations();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchAllocations();
            // scrollToTop();
        }
        const addNewAllocation = () =>{
            store.dispatch("Project_Allocations/updateState",{selectedAllocation:null, selectedEmployee:null, selectedProject:null});
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Project_Allocations/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const assignID = row['project_allocation_id'];
                let formData = {
                    company: companyID.value,
                    project_allocation: assignID
                }
                await store.dispatch('Project_Allocations/fetchProjectAllocation',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.333';

            }else if(action == 'delete'){
                const assignID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    project_allocation: assignID
                }
                await store.dispatch('Project_Allocations/deleteProjectAllocation',formData).
                then(()=>{
                    searchAllocations();
                })
            }else if(action == 'view'){
                console.log("VIEWING TAKING PLACE");
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCasesList = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-disciplinary-cases-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadCasesExcel = () =>{

        };
        const downloadCasesCSV = () =>{
   
        };
        onBeforeMount(()=>{
            searchAllocations();
            fetchProjects();
            fetchEmployees();
            
        })
        return{
            title, searchAllocations,resetFilters, addButtonLabel, searchFilters, tableColumns, allocList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewAllocation, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveAllocation, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeAllocation, removeAllocations,addingRight,removingRight,rightsModule,printCasesList,selectSearchQuantity,selectedValue,
            downloadCasesCSV,downloadCasesExcel
        }
    }
};
</script>